import { render, staticRenderFns } from "./MatchFilters.vue?vue&type=template&id=3bc176ec&scoped=true&"
import script from "./MatchFilters.vue?vue&type=script&lang=js&"
export * from "./MatchFilters.vue?vue&type=script&lang=js&"
import style0 from "./MatchFilters.vue?vue&type=style&index=0&id=3bc176ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc176ec",
  null
  
)

export default component.exports